import { render, staticRenderFns } from "./CadastroAdministracao.vue?vue&type=template&id=befcd768&scoped=true"
import script from "./CadastroAdministracao.vue?vue&type=script&lang=js"
export * from "./CadastroAdministracao.vue?vue&type=script&lang=js"
import style0 from "./CadastroAdministracao.vue?vue&type=style&index=0&id=befcd768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befcd768",
  null
  
)

export default component.exports